






























































































































































import menu from "@/store/modules/ApplicationModule/data/menu";
import moment from "moment";
import Vue from "vue";
import { mapState } from "vuex";

// Vue components
import AppPage from "@/components/AppPage.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";

// Model
import VFaIcon from "@/components/VFaIcon.vue";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DownloadOrganizationsLicensesCommand } from "@/model/communication/organizations/DownloadOrganizationsLicensesCommand";
import { EditOrganizationsLicensesCommand } from "@/model/communication/organizations/EditOrganizationsLicensesCommand";
import { GetOrganizationsCommand } from "@/model/communication/organizations/GetOrganizationsCommand";
import { FetchUserEventsCommand } from "@/model/communication/userEvents/FetchUserEventsCommand";
import { FetchUserEventsResData } from "@/model/communication/userEvents/FetchUserEventsResData";
import { LicenseModuleEnum, convertByEnumName, defaultLicenseModuleEnumSorting, getLicenseModuleLabel } from "@/model/data/License/LicenseModuleEnum";
import { UserEventTypeEnum } from "@/model/data/enums/UserEventTypeEnum";
import { Organization } from "@/model/data/organizations/Organization";
import { getFoldersPathFromFolderId } from "@/utility/TreeviewUtility";
import _ from "lodash";

export default Vue.extend({
    components: { AppPage, VFaIcon, ColumnVisibilityFilter },
    data() {
        return {
            moment,
            LicenseModuleEnum,
            loading: false,
            downloadLoading: false,
            organizations: [],
            organizationsBeforeEditing: [],
            search: "",
            menuDatePicker: [],
            notes: "",
            userEvents: [],
            openHistoryDialog: false,
            selectedOrganization: null,
            headers: [],
        };
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),

        menuEntry() {
            return menu.find((m) => m.name == "Tools").children.find((c) => c.name == "Organizations Licenses");
        },

        closeToExpireDate() {
            let today: Date = new Date();
            today.setDate(today.getDate() + 14);
            return today;
        },

        availableLicenseModules() {
            let tempRes = [];
            let res = [];

            this.organizations.forEach((organization: Organization) => {
                if (organization.licensesData != null && organization.licensesData.licensesByModule != null)
                    for (let index in organization.licensesData.licensesByModule) {
                        // if (
                        //     organization.licensesData.licensesByModule[index].value > 0 &&
                        //     !tempRes.includes(LicenseModuleEnum[organization.licensesData.licensesByModule[index].key])
                        // )
                        tempRes.push(LicenseModuleEnum[organization.licensesData.licensesByModule[index].key]);
                    }
            });

            // ordino come nel menu
            this.defaultLicenseModuleEnumSorting()
                .map((l) => LicenseModuleEnum[l])
                .forEach((moduleEnumValue) => {
                    if (tempRes.includes(moduleEnumValue)) res.push(moduleEnumValue);
                });

            return res;
        },

        availableHeaders() {
            let res = [];

            res.push({ text: this.$t("organizationsLicenses.organization"), value: "name" });
            res.push({ text: this.$t("organizationsLicenses.installationCount"), value: "installationsCount", align: "center" });

            this.availableLicenseModules.forEach((availableLicenseModule) => {
                res.push({
                    text: this.$t(getLicenseModuleLabel(LicenseModuleEnum[availableLicenseModule])),
                    value: LicenseModuleEnum[availableLicenseModule],
                    sortable: false,
                    width: "8%",
                });
            });

            res.push({ text: this.$t("organizationsLicenses.expirationDate"), value: "licensesData.expirationDate" });
            res.push({ text: this.$t("organizationsLicenses.lastUpdate"), value: "licensesData.lastUpdateUTC" });

            return res;
        },

        userEventsHeaders() {
            let res = [];
            res.push({ text: this.$t("common.notes"), value: "notes" });
            res.push({ text: this.$t("organizationsLicenses.organizationName"), value: "organizationName" });

            this.availableLicenseModules.forEach((availableLicenseModule) => {
                res.push({
                    text: this.$t(getLicenseModuleLabel(LicenseModuleEnum[availableLicenseModule])),
                    value: LicenseModuleEnum[availableLicenseModule],
                    sortable: false,
                    width: "8%",
                });
            });

            res.push({ text: this.$t("organizationsLicenses.expirationDate"), value: "expirationDate" });
            res.push({ text: this.$t("organizationsLicenses.timestamp"), value: "timestamp" });

            return res;
        },

        userEventsUI() {
            if (this.userEvents == null || this.userEvents.length < 1 || this.selectedOrganization == null) return [];
            let res = [];

            this.userEvents.forEach((userEvent) => {
                userEvent.extraData.Organizations.filter((o) => o.Id == this.selectedOrganization.id).forEach((o) => {
                    let temp = [];
                    for (let key in o.LicensesData.LicensesByModule) temp.push({ key: LicenseModuleEnum[key], value: o.LicensesData.LicensesByModule[key] });
                    res.push({
                        notes: userEvent.extraData.Notes,
                        organizationId: o.Id,
                        organizationName: o.Name,
                        licensesByModule: temp,
                        expirationDate: o.LicensesData.ExpirationDate.substring(10, 0),
                        timestamp: userEvent.timestamp.replace("T", " "),
                    });
                });
            });

            return res;
        },

        changedOrganizationIds() {
            let res = [];
            this.organizationsBeforeEditing
                .filter((o: Organization) => o.licensesData)
                .forEach((organizationBeforeEditing: Organization) => {
                    if (this.organizations.some((o: Organization) => o.id == organizationBeforeEditing.id)) {
                        if (
                            JSON.stringify(organizationBeforeEditing.licensesData) !=
                            JSON.stringify(this.organizations.filter((o: Organization) => o.id == organizationBeforeEditing.id)[0].licensesData)
                        )
                            res.push(organizationBeforeEditing.id);
                    }
                });
            return res;
        },
    },
    methods: {
        getLicenseModuleLabel,
        defaultLicenseModuleEnumSorting,
        getFoldersPathFromFolderId,
        convertByEnumName,

        async reset() {
            this.loading = false;
            this.organizations = [];

            this.organizationsBeforeEditing = [];
            this.search = "";
            this.notes = "";
            this.openHistoryDialog = false;
            await this.getOrganizations();
            await this.getUserEvents();
            this.selectedOrganization = null;
        },

        openHistory(organization) {
            this.selectedOrganization = organization;
            this.openHistoryDialog = true;
        },

        async save() {
            try {
                if (!this.loading) {
                    this.loading = true;
                    let changedOrganizations = this.organizations.filter((o) => this.changedOrganizationIds.includes(o.id));
                    const res = await new EditOrganizationsLicensesCommand(changedOrganizations, this.notes).execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        await this.reset();
                    }
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during EditOrganizationsLicensesCommand execution: ", e);
                this.loading = false;
            }
        },

        async getOrganizations() {
            try {
                if (!this.loading) {
                    this.loading = true;
                    const res = await new GetOrganizationsCommand().execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.organizations = _.cloneDeep(res.organizations);
                        this.organizationsBeforeEditing = _.cloneDeep(res.organizations);
                    }
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during GetOrganizationsCommand execution: ", e);
                this.loading = false;
            }
        },

        getFoldersPath(folderId) {
            let result = this.getFoldersPathFromFolderId(this.deviceTree, folderId);
            return result
                .map((o) => o.name)
                .join(" / ")
                .replace("/ /", "/");
        },

        async exportData() {
            try {
                if (!this.downloadLoading) {
                    this.downloadLoading = true;
                    const res = await new DownloadOrganizationsLicensesCommand().execute();
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.downloadLoading = false;
                }
            } catch (e) {
                console.log("Something went wrong, server side");
                this.downloadLoading = false;
            }
        },

        async getUserEvents() {
            try {
                this.loading = true;
                let reqData: any = {};
                reqData.queryLimit = -1;
                reqData.eventTypes = [];
                reqData.eventTypes.push(UserEventTypeEnum.editOrganizationsLicenses);
                reqData.userEventEndDate = new Date();
                let response: FetchUserEventsResData = await new FetchUserEventsCommand(reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) this.userEvents = response.userEvents;
                this.loading = false;
            } catch (e) {
                console.log("Something went wrong sending FetchUserEventsCommand request ", e);
                this.loading = false;
            }
        },
    },
    async mounted() {
        await this.reset();
        this.headers = [];
        this.availableHeaders.forEach((h) => {
            h.enabled = true;
            this.headers.push(h);
        });
    },
});
